import { Routes, Route } from "react-router-dom";
import Dashboard from "pages/dashboard";
import StaffManagementPage from "pages/staff-management";
import ProtectedRoute from "components/ProtectedRoute";

const ProtectedRoutes = () => {
    return (
        <Routes>
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/staff-management"
                element={
                    <ProtectedRoute>
                        <StaffManagementPage />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
};

export default ProtectedRoutes;
